import { forEach } from './functions';
const Easing = {
    easeInOut(pos) {
        return ((-Math.cos(pos * Math.PI) / 2) + 0.5);
    }
};
/**
 * An animation ticker driving an adapter which sets a particular
 * property in function of the tick.
 *
 * @type {*}
 */
class Ticker {
    constructor() {
        this.adapters = [];
        this.target = 0;
        this.tick = 0;
        this.interval = 20;
        this.duration = 800;
        this.lastTime = null;
        this.handlers = [];
        this.timerDelegate = () => { };
        this.intervalId = null;
        this.caller = null;
        this.timerDelegate = () => {
            this.onTimerEvent();
        };
    }
    ;
    addAdapter(a) {
        this.adapters.push(a);
    }
    ;
    onComplete(handler) {
        this.handlers.push(handler);
    }
    ;
    removeHandler(handler) {
        this.handlers = this.handlers.filter((h) => {
            return h !== handler;
        });
    }
    ;
    trigger() {
        if (this.handlers) {
            forEach(this.handlers, (h) => {
                return h.call(this.caller !== null ? this.caller : this);
            });
        }
    }
    ;
    onStep() {
    }
    ;
    seekTo(to) {
        this.seekFromTo(this.tick, to);
    }
    ;
    seekFromTo(from, to) {
        this.target = Math.max(0, Math.min(1, to));
        this.tick = Math.max(0, Math.min(1, from));
        this.lastTime = new Date().getTime();
        if (!this.intervalId) {
            this.intervalId = window.setInterval(this.timerDelegate, this.interval);
        }
    }
    ;
    stop() {
        if (this.intervalId) {
            window.clearInterval(this.intervalId);
            this.intervalId = null;
            // this.trigger.call(this);
            this.trigger();
            // this.next();
        }
    }
    ;
    play(origin) {
        if (this.adapters.length === 0) {
            return;
        }
        if (origin !== null) {
            this.caller = origin;
        }
        this.initState();
        this.seekFromTo(0, 1);
    }
    ;
    reverse() {
        this.seekFromTo(1, 0);
    }
    ;
    initState() {
        if (this.adapters.length === 0) {
            return;
        }
        for (let i = 0; i < this.adapters.length; i++) {
            this.adapters[i].initState();
        }
    }
    ;
    propagate() {
        const value = Easing.easeInOut(this.tick);
        for (let i = 0; i < this.adapters.length; i++) {
            this.adapters[i].update(value);
        }
    }
    ;
    onTimerEvent() {
        const now = new Date().getTime();
        const timePassed = now - this.lastTime;
        this.lastTime = now;
        const movement = (timePassed / this.duration) * (this.tick < this.target ? 1 : -1);
        if (Math.abs(movement) >= Math.abs(this.tick - this.target)) {
            this.tick = this.target;
        }
        else {
            this.tick += movement;
        }
        try {
            this.propagate();
        }
        finally {
            this.onStep.call(this);
            if (this.target === this.tick) {
                this.stop();
            }
        }
    }
}
export { Ticker };
